function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.39 56.97"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M338.63 417h-67.32l17.82-17.83-5.41-5.41-21.66 21.65-5.41 5.42 27.07 27.07 5.41-5.42-17.82-17.82h67.32Z",
    transform: "translate(-255.24 -392.33)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2
    }
  }));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NC4zOSA1Ni45NyI+CjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDAwO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPgo8cGF0aCBpZD0iUGF0aF8yMSIgZGF0YS1uYW1lPSJQYXRoIDIxIiBjbGFzcz0iY2xzLTEiIGQ9Ik0zMzguNjMsNDE3SDI3MS4zMWwxNy44Mi0xNy44My01LjQxLTUuNDEtMjEuNjYsMjEuNjUtNS40MSw1LjQyLDI3LjA3LDI3LjA3LDUuNDEtNS40Mi0xNy44Mi0xNy44Mmg2Ny4zMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNTUuMjQgLTM5Mi4zMykiLz48L3N2Zz4=";